import { useSidePanel } from 'features/side-panels/hooks/useSidePanel';
import { useTranslation } from 'react-i18next';
import { useContentLibrary } from 'features/content-library/useContentLibrary';

export const useContentLibraryControl = () => {
  const { t } = useTranslation('room');

  const { isPanelVisible, togglePanel } = useSidePanel();

  const { isFeatureAvailable, sharedContentOnlyAvailable } = useContentLibrary();

  const active = isPanelVisible('content-library');

  const toggleContentLibraryPanel = () => {
    togglePanel('content-library');
  };

  return {
    active,
    label: sharedContentOnlyAvailable ? t('toolbar.shared_files') : t('toolbar.content_library'),
    toggleContentLibrary: toggleContentLibraryPanel,
    isFeatureAvailable,
    sharedContentOnlyAvailable,
    icon: 'content-folder-1',
  };
};
